@if (data.adminDto) {
  <div class="dialog-root">
    <h2 mat-dialog-title>{{ "admin.edit_admin_type" | transloco }}</h2>

    <mat-dialog-content class="column-gap">
      <div class="mdc-list-item__primary-text">{{ data.adminDto.firstName }} {{ data.adminDto.lastName }}
        ({{ data.adminDto.email }})
      </div>

      <mat-form-field hideRequiredMarker="true">
        <mat-label>{{ "admin.admin_type.label" | transloco }}</mat-label>
        <mat-select [formControl]="adminTypeSelector">
          @for (adminType of adminTypes; track $index) {
            <mat-option [value]="adminType">{{ adminType | adminType }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button (click)="close()" mat-button type="button">{{ "button.cancel" | transloco }}</button>
      <button (click)="editAdminType()" mat-flat-button type="submit">{{ "admin.edit_admin_type" | transloco }}</button>
    </mat-dialog-actions>
  </div>
}
